<template>
  <transition name="fade">
    <div class="level3-modal-container">
      <div class="lv3-title-text">Edit Data Informasi</div>
      <div class="lv3-edit-form">
        <div class="edit-form-wrapper">
          <div>Nama Vendor</div>
          <input class="lv3-input-text" :placeholder="vendorName" type="text" v-model="vendorName"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="vendor-form">
          <div>
            Bentuk Badan Usaha
          </div>
          <select v-model="$store.state.addEdit.badan_usaha_id" class="lv3-input-text">
            <option v-for="(option, index) in bentukBadanUsaha" :key="index" :value="option.id">
              {{ option.desc }}
            </option>
          </select>
        </div>
        <div class="vendor-form">
          <p class="vendor-form-label">
            Tanggal Berdiri
          </p>
          <input class="vendor-input-date" type="date" v-model="$store.state.addEdit.tglBerdiri" />
        </div>
        <div class="edit-form-wrapper">
          <div>Isupplier Code</div>
          <input class="lv3-input-text" :placeholder="isupplier_code" type="text" v-model="isupplier_code"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Ariba Code</div>
          <input class="lv3-input-text" :placeholder="ariba_code" type="text" v-model="ariba_code"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>BCE Code</div>
          <input class="lv3-input-text" :placeholder="bce_code" type="text" v-model="bce_code"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>GEMS Code</div>
          <input class="lv3-input-text" :placeholder="gems_code" type="text" v-model="gems_code"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>BKES Code</div>
          <input class="lv3-input-text" :placeholder="bkes_code" type="text" v-model="bkes_code"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Alamat</div>
          <textarea class="lv3-input-text" v-model="address" autocomplete="alamat"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Negara</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Negara" label="negara" :options="countries"
              v-model="choosedCountry" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper" v-if="choosedCountry && choosedCountry.id == 63">
          <div>Provinsi</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Provinsi" label="desc" :options="provinces"
              v-model="choosedProvince" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper" v-if="choosedProvince">
          <div>Kota / Kabupaten</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Kota / Kabupaten" label="desc" :options="cities"
              v-model="choosedCity" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper" v-if="choosedCity">
          <div>Kecamatan</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Kecamatan" label="desc" :options="districs"
              v-model="choosedDistric" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper" v-if="choosedDistric">
          <div>Kelurahan</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Kelurahan" label="desc" :options="villages"
              v-model="choosedVillage" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper" v-if="choosedVillage">
          <div>Kode Pos</div>
          <input class="lv3-input-text" :placeholder="kodepos" type="text" v-model="kodepos" />
        </div>
        <div class="edit-form-wrapper" v-if="choosedCountry && choosedCountry.id != 63">
          <div>Provinsi Asing</div>
          <input class="lv3-input-text" :placeholder="provinsiAsing" type="text" v-model="provinsiAsing"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper" v-if="choosedCountry && choosedCountry.id != 63">
          <div>Kota Asing</div>
          <input class="lv3-input-text" :placeholder="kotaAsing" type="text" v-model="kotaAsing"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper" v-if="choosedCountry && choosedCountry.id != 63">
          <div>Kode Pos Asing</div>
          <input class="lv3-input-text" :placeholder="kodeposAsing" type="text" v-model="kodeposAsing" />
        </div>
        <div class="edit-form-wrapper">
          <div>No Handphone</div>
          <input class="lv3-input-text" :placeholder="phoneNumber" type="text" v-model="phoneNumber" />
        </div>
        <div class="edit-form-wrapper">
          <div>Email</div>
          <input class="lv3-input-text" :placeholder="emailPerusahaan" type="text" v-model="emailPerusahaan"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <!-- <div class="edit-form-wrapper">
          <div>Nama Bank</div>
          <div class="lv3-input-text">
            <v-select
              class="style-chooser"
              placeholder="Pilih Bank"
              label="desc"
              :options="bankList"
              v-model="selectedBank"
              autocomplete="bank"
            />
          </div>
        </div> -->
        <div class="edit-form-wrapper">
          <div>Nama Bank</div>
          <input class="lv3-input-text" type="text" v-model="selectedBank"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Kantor Cabang</div>
          <input class="lv3-input-text" :placeholder="bankBranchOffice" type="text" v-model="bankBranchOffice"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Mata Uang</div>
          <div class="lv3-input-text">
            <v-select class="style-chooser" placeholder="Pilih Mata Uang" label="kode_mata_uang" :options="countries"
              v-model="mataUang" autocomplete="negara" />
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Rekening</div>
          <input class="lv3-input-text" :placeholder="accountNumber" type="text" v-model="accountNumber" />
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor NPWP</div>
          <the-mask class="lv3-input-text" :mask="['##.###.###.#-###.###']" placeholder="XX.XXX.XXX.X-XXX.XXX"
            v-model="npwpBank" />
        </div>
        <hr />
        <div class="edit-form-wrapper">
          <div>AFILIASI</div>
          <div class="half-input-wrapper" style="width: 100% !important">
            <div class="hiw-multiple" style="width: 100% !important">
              <label class="hiw-4-row"><input type="checkbox" v-model="afiliasi_gems" value="0"
                  style="margin-right: 10px" />GEMS</label>
              <label class="hiw-4-row"><input type="checkbox" v-model="afiliasi_bce" value="0"
                  style="margin-right: 10px" />BCE</label>
              <label class="hiw-4-row"><input type="checkbox" v-model="afiliasi_bkes" value="0"
                  style="margin-right: 10px" />BKES</label>
              <label class="hiw-4-row"><input type="checkbox" v-model="afiliasi_no" value="0"
                  style="margin-right: 10px" />TIDAK ADA AFILIASI</label>
            </div>
          </div>
        </div>

        <div class="edit-form-wrapper">
          <div>
            <div class="vendor-form100">
              <div class="label-100">
                Jelaskan hubungan dengan Sinarmas Mining Group!
              </div>
              <textarea class="input-100" v-model="relasi_desc"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
            </div>

            <div class="vendor-form100">
              <div class="label-100">
                Apa nama Group Keluarga Anda di Sinarmas Mining Group?
              </div>
              <textarea class="input-100" v-model="relasi_group"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
            </div>
            <hr />
            <div class="vendor-form100">
              <div class="label-100 mb10">
                Identitas Nama Orang yang Bersangkutan dengan Anda
              </div>
              <div class="vendor-form">
                <p class="vendor-form-label">Nama</p>
                <input type="text" class="lv3-input-text" v-model="relasi_nama"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </div>

              <div class="vendor-form">
                <p class="vendor-form-label">Jabatan</p>
                <input type="text" class="lv3-input-text" v-model="relasi_jabatan"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </div>

              <div class="vendor-form">
                <p class="vendor-form-label">Departemen</p>
                <input type="text" class="lv3-input-text" v-model="relasi_departemen"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  props: ['propsData'],
  data() {
    return {
      bentukBadanUsaha: [],
      countries: [],
      provinces: [],
      cities: [],
      districs: [],
      villages: [],
      bankList: [],
      afiliasi_no: 0,
    }
  },
  created() {
    this.getBentukBadanUsaha()
    this.getCountry()
    this.getProvince()
    // this.getBank()
  },
  computed: {
    vendorName: {
      get: function () {
        return this.$store.state.addEdit.vendorName
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'vendorName',
          value: newValue,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'pemilikBank',
          value: newValue,
        })
      },
    },
    isupplier_code: {
      get: function () {
        return this.$store.state.addEdit.isupplier_code
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'isupplier_code',
          value: newValue,
        })
      },
    },
    ariba_code: {
      get: function () {
        return this.$store.state.addEdit.ariba_code
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'ariba_code',
          value: newValue,
        })
      },
    },
    bce_code: {
      get: function () {
        return this.$store.state.addEdit.bce_code
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'bce_code',
          value: newValue,
        })
      },
    },
    gems_code: {
      get: function () {
        return this.$store.state.addEdit.gems_code
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'gems_code',
          value: newValue,
        })
      },
    },
    bkes_code: {
      get: function () {
        return this.$store.state.addEdit.bkes_code
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'bkes_code',
          value: newValue,
        })
      },
    },
    provinsiAsing: {
      get() {
        return this.$store.state.addEdit.provinsiAsing
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'provinsiAsing',
          value: newValue && newValue,
        })
      },
    },
    kotaAsing: {
      get() {
        return this.$store.state.addEdit.kotaAsing
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kotaAsing',
          value: newValue && newValue,
        })
      },
    },
    kodeposAsing: {
      get() {
        return this.$store.state.addEdit.kodeposAsing
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodeposAsing',
          value: newValue,
        })
      },
    },
    choosedCountry: {
      get() {
        return this.$store.state.addEdit.choosedCountry
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedCountry',
          value: newValue,
        })

        if (newValue) {
          if (newValue.id == 63) {
            this.$store.commit('addEdit/SET_STATE_DATA', {
              name: 'phoneCode',
              value: '+62',
            })
            this.$store.commit('addEdit/SET_STATE_DATA', {
              name: 'mataUang',
              value: 'IDR',
            })
            this.$store.commit('addEdit/SET_STATE_DATA', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('addEdit/SET_STATE_DATA', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('addEdit/SET_STATE_DATA', {
              name: 'phonePic',
              value: '+62',
            })
            this.getProvince()
          }
        } else {
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'choosedProvince',
            value: null,
          })
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'choosedCity',
            value: null,
          })
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'choosedDistric',
            value: null,
          })
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'choosedVillage',
            value: null,
          })
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'kodepos',
            value: '',
          })
          this.$store.commit('addEdit/SET_STATE_DATA', {
            name: 'phoneCode',
            value: '',
          })
        }
      },
    },
    choosedProvince: {
      get() {
        return this.$store.state.addEdit.choosedProvince
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedProvince',
          value: newValue,
        })
      },
    },
    choosedCity: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedProvince.id')) {
          this.getCity()
        }
        return this.$store.state.addEdit.choosedCity
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedCity',
          value: newValue,
        })
      },
    },
    choosedDistric: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedCity.id')) {
          this.getDistric()
        }
        return this.$store.state.addEdit.choosedDistric
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: newValue,
        })
      },
    },
    choosedVillage: {
      get() {
        return this.$store.state.addEdit.choosedVillage
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: newValue,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue ? newValue.kodepos : '',
        })
      },
    },
    kodepos: {
      get() {
        return this.$store.state.addEdit.kodepos
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue,
        })
      },
    },
    phoneCode: {
      get() {
        return this.$store.state.addEdit.phoneCode
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'phoneCode',
          value: newValue,
        })
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.addEdit.phoneNumber
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'phoneNumber',
          value: newValue,
        })
      },
    },
    emailPerusahaan: {
      get: function () {
        return this.$store.state.addEdit.emailPerusahaan
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'emailPerusahaan',
          value: newValue,
        })
      },
    },
    address: {
      get: function () {
        return this.$store.state.addEdit.address
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'address',
          value: newValue,
        })
      },
    },
    selectedBank: {
      get: function () {
        return this.$store.state.addEdit.selectedBank
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'selectedBank',
          value: newValue,
        })
      },
    },
    bankBranchOffice: {
      get: function () {
        return this.$store.state.addEdit.bankBranchOffice
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'bankBranchOffice',
          value: newValue,
        })
      },
    },
    accountNumber: {
      get: function () {
        return this.$store.state.addEdit.accountNumber
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'accountNumber',
          value: newValue,
        })
      },
    },
    mataUang: {
      get: function () {
        return this.$store.state.addEdit.mataUang
      },
      set: function (newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'mataUang',
          value: newValue.kode_mata_uang,
        })
      },
    },
    npwpBank: {
      get: function () {
        return this.$store.state.addEdit.npwpBank
      },
      set: function (newValue) {
        // XX.XXX.XXX.X-XXX.XXX
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'npwpBank',
          value: newValue,
        })
      },
    },
    afiliasi_gems: {
      get() {
        return this.$store.state.addEdit.afiliasi_gems
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'afiliasi_gems',
          value: newValue,
        })
      },
    },
    afiliasi_bce: {
      get() {
        return this.$store.state.addEdit.afiliasi_bce
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'afiliasi_bce',
          value: newValue,
        })
      },
    },
    afiliasi_bkes: {
      get() {
        return this.$store.state.addEdit.afiliasi_bkes
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'afiliasi_bkes',
          value: newValue,
        })
      },
    },
    relasi_desc: {
      get() {
        return this.$store.state.addEdit.relasi_desc
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'relasi_desc',
          value: newValue,
        })
      },
    },
    relasi_group: {
      get() {
        return this.$store.state.addEdit.relasi_group
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'relasi_group',
          value: newValue,
        })
      },
    },
    relasi_nama: {
      get() {
        return this.$store.state.addEdit.relasi_nama
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'relasi_nama',
          value: newValue,
        })
      },
    },
    relasi_jabatan: {
      get() {
        return this.$store.state.addEdit.relasi_jabatan
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'relasi_jabatan',
          value: newValue,
        })
      },
    },
    relasi_departemen: {
      get() {
        return this.$store.state.addEdit.relasi_departemen
      },
      set(newValue) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'relasi_departemen',
          value: newValue,
        })
      },
    },
  },
  watch: {
    choosedCountry: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue && newValue.id == 63) {
        this.provinsiAsing = null
        this.kotaAsing = null
        this.kodeposAsing = null
      }
    },
    choosedProvince: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedCity',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      } else {
        this.getCity()
      }
    },
    choosedCity: function (newChoosedCity, oldChoosedCity) {
      if (newChoosedCity !== oldChoosedCity && newChoosedCity == null) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      } else {
        this.getDistric()
      }
    },
    choosedDistric: function (newChoosedDistric, oldChoosedDistric) {
      if (
        newChoosedDistric !== oldChoosedDistric &&
        newChoosedDistric == null
      ) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      } else {
        this.getVillage()
      }
    },
    choosedVillage: function (newChoosedVillage, oldChoosedVillage) {
      if (
        newChoosedVillage !== oldChoosedVillage &&
        newChoosedVillage == null
      ) {
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      }
    },
    afiliasi_gems: function (newValue, oldValue) {
      if (newValue == 1) {
        this.afiliasi_no = 0
      }
    },
    afiliasi_bce: function (newValue, oldValue) {
      if (newValue == 1) {
        this.afiliasi_no = 0
      }
    },
    afiliasi_bkes: function (newValue, oldValue) {
      if (newValue == 1) {
        this.afiliasi_no = 0
      }
    },
    afiliasi_no: function (newValue, oldValue) {
      if (newValue == 1) {
        this.afiliasi_gems = 0
        this.afiliasi_bce = 0
        this.afiliasi_bkes = 0
        this.relasi_desc = null
        this.relasi_group = null
        this.relasi_nama = null
        this.relasi_jabatan = null
        this.relasi_departemen = null
      }
    },
  },
  methods: {
    async getBentukBadanUsaha() {
      const {
        bidang_usaha_id,
        type_pendaftaran_id,
      } = this.$store.state.level1.information.badan_usaha

      const url = `${api}/api/v1/badan-usaha?page=1&limit=100&bidang_usaha_id=${bidang_usaha_id}&type_pendaftaran_id=${type_pendaftaran_id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.bentukBadanUsaha = data && data.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    closeModal() {
      const self = this
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'showEditInfo',
        status: false,
      })
    },
    confirm() {
      let isValidation = this.$route.path.split('/')[1]

      if (isValidation == 'validation') {
        this.$store.dispatch('addEdit/updateInformationValidation')
      } else {
        this.$store.dispatch('addEdit/updateInformation')
      }
    },
    async getBank() {
      try {
        const url = `${api}/api/v1/bank?page=1&limit=100`
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.bankList = data.data
      } catch (error) { }
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) { }
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) { }
    },
    async getCity() {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.$get(
        this.$store,
        'state.addEdit.choosedProvince.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.cities = data.data
      } catch (error) { }
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.$get(
        this.$store,
        'state.addEdit.choosedCity.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) { }
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.$get(
        this.$store,
        'state.addEdit.choosedDistric.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) { }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
